











































































































































































































import PhotoHeader from '@/components/organization/PhotoHeader.vue'
import Main from '@/components/organization/Main.vue'
import Paragraph from '@/components/organization/Paragraph.vue'
import Carousel from '@/components/home/Carousel.vue'


export default {
  components : {
    Carousel,
    Main,
    Paragraph
  }  

}



